import { useState, useRef, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import useAskModal from 'components/Modals/AskBeforeLeave/useAskModal';
import { Props } from './types';

const useBlockRoute = ({
  shouldBlock,
  onPublish,
  ignoreRoutePattern,
}: Props) => {
  const history = useHistory();
  const [targetUrl, setTargetUrl] = useState('');
  const unblockHandle = useRef<any>();

  const onDiscard = useCallback(() => {
    if (unblockHandle) {
      unblockHandle.current();
    }
    history.push(targetUrl);
  }, [history, targetUrl]);

  const onPublishEnd = useCallback(() => {
    if (unblockHandle) {
      unblockHandle.current();
    }
    history.push(targetUrl);
  }, [history, targetUrl]);

  const {
    modalIsOpen,
    isPublishing,
    openModal,
    handleCancel,
    handleDiscard,
    handleConfirm,
  } = useAskModal({ onPublish, onPublishEnd, onDiscard });

  useEffect(() => {
    // eslint-disable-next-line consistent-return
    unblockHandle.current = history.block((targetLocation: any) => {
      const ignoreRoute =
        !!ignoreRoutePattern && ignoreRoutePattern(targetLocation.pathname);

      if (shouldBlock && !ignoreRoute) {
        setTargetUrl(targetLocation);
        openModal();
        return false;
      }
    });
    return () => {
      unblockHandle.current();
    };
  }, [history, shouldBlock, openModal, ignoreRoutePattern]);

  return {
    modalIsOpen,
    isPublishing,
    openModal,
    handleCancel,
    handleDiscard,
    handleConfirm,
  };
};

export default useBlockRoute;

// TODO: TFR-47 move hooks and effects into proper repository (hooks or utils)
